import { ModuleGridType } from 'types/global'
import type { BasicAccessorConfig } from './types'

const setter = ({ moduleGrid, value }: { moduleGrid: ModuleGridType; value: number }) => {
  window.editor.execute(new window.SetPanelConfigurationCommand(moduleGrid, 'modulesPerCol', value))
}

const getter = (moduleGrid: ModuleGridType): number => {
  return moduleGrid.modulesPerCol()
}

export const modulesPerColAccessorConfig: BasicAccessorConfig<number> = {
  get: getter,
  set: setter,
}
